import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import classnames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import ValidationGroupable from '../ValidationGroupable';
import ValidationGroupContext from '../ValidationGroupContext';
import DataPathContext from '../DataPathContext';
import { useRowModel } from '../../hooks/useRowModel';
export const getValidationGroupItems = (row, name)=>{
    return row.getIn([
        '$validationGroups',
        name
    ]) || [];
};
const ValidationGroup = (props)=>{
    const name = useMemo(()=>{
        return props.name || uniqueId();
    }, [
        props.name
    ]);
    const dataPath = useContext(DataPathContext);
    const oldValidationGroup = useContext(ValidationGroupContext);
    const newValidationGroup = useMemo(()=>({
            name,
            path: dataPath
        }), [
        dataPath,
        name
    ]);
    const row = useRowModel();
    const { isDirty, errors } = useMemo(()=>{
        const validationGroupItems = row.getIn([
            '$validationGroups',
            name
        ]) || [];
        return {
            isDirty: validationGroupItems.some((x)=>x.$isDirty),
            errors: validationGroupItems.reduce((r, r2)=>[
                    ...r,
                    ...r2.$errors
                ], [])
        };
    }, [
        name,
        row
    ]);
    const isFatal = errors.some((x)=>x.isFatal);
    const isWarning = errors.some((x)=>!x.isFatal);
    const c = classnames({
        'is-error': isDirty && isFatal,
        'is-warning': isDirty && !isFatal && isWarning
    });
    if (oldValidationGroup) {
        return /*#__PURE__*/ _jsx(ValidationGroupContext.Provider, {
            value: newValidationGroup,
            children: /*#__PURE__*/ _jsx(ValidationGroupable, {
                validationGroup: oldValidationGroup,
                idPrefix: `ValidationGroup_${name}_`,
                errors: [],
                isDirty: isDirty,
                className: c,
                children: props.children
            })
        });
    }
    return /*#__PURE__*/ _jsx(ValidationGroupContext.Provider, {
        value: newValidationGroup,
        children: /*#__PURE__*/ _jsx("div", {
            className: c,
            children: props.children
        })
    });
};
export default ValidationGroup;
